var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOrderHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16675 16H14.1667V18H7.16675V16ZM7.16675 12H17.1667V14H7.16675V12ZM7.16675 8H17.1667V10H7.16675V8ZM19.1667 4H14.9867C14.5667 2.84 13.4667 2 12.1667 2C10.8667 2 9.76675 2.84 9.34675 4H5.16675C5.02675 4 4.89675 4.01 4.76675 4.04C4.37675 4.12 4.02675 4.32 3.75675 4.59C3.57675 4.77 3.42675 4.99 3.32675 5.23C3.22675 5.46 3.16675 5.72 3.16675 6V20C3.16675 20.27 3.22675 20.54 3.32675 20.78C3.42675 21.02 3.57675 21.23 3.75675 21.42C4.02675 21.69 4.37675 21.89 4.76675 21.97C4.89675 21.99 5.02675 22 5.16675 22H19.1667C20.2667 22 21.1667 21.1 21.1667 20V6C21.1667 4.9 20.2667 4 19.1667 4ZM12.1667 3.75C12.5767 3.75 12.9167 4.09 12.9167 4.5C12.9167 4.91 12.5767 5.25 12.1667 5.25C11.7567 5.25 11.4167 4.91 11.4167 4.5C11.4167 4.09 11.7567 3.75 12.1667 3.75ZM19.1667 20H5.16675V6H19.1667V20Z",
    fill: "#3D454D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrderHistory);
export default __webpack_public_path__ + "static/media/ic_order_history.ea159fb2382fbec97de30e88dafd2712.svg";
export { ForwardRef as ReactComponent };